export default (ref: any) => {
  setTimeout(() => {
    if (ref.current && ref.current.focus) ref.current.focus();
  }, 0);
};
